import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect, useImperativeHandle } from "react";
import { useWormhole } from "../../../../hooks/index.js";
import { useEditorLayout } from "../../EditorLayout/hooks/useEditorLayout.js";
import { useEditorAPI, useEditorData } from "../../context/index.js";
function useEditor(props) {
  const { actions, disabled } = props;
  const { toHTML, toJSON, fromHTML, fromJSON } = useEditorAPI();
  const { cssRules, toolbarVisible, footerActionTarget, quickInsertTarget, footerContentTarget, childrenTarget } = useEditorData();
  const [editor] = useLexicalComposerContext();
  const editorChildren = useEditorLayout(childrenTarget);
  const { worms: quickInserts } = useWormhole(quickInsertTarget);
  const { worms: footerActions } = useWormhole(footerActionTarget);
  const { worms: footerContents } = useWormhole(footerContentTarget);
  const enableFooterPadding = quickInserts.length + footerActions.length + footerContents.length > 0;
  useEffect(() => {
    editor.setEditable(!disabled);
  }, [disabled, editor]);
  useImperativeHandle(
    actions,
    () => ({
      toHTML,
      toJSON,
      fromHTML,
      fromJSON
    }),
    [fromHTML, fromJSON, toHTML, toJSON]
  );
  return {
    cssRules,
    footerActions,
    footerContents,
    editorChildren,
    toolbarVisible,
    enableFooterPadding
  };
}
export {
  useEditor
};
//# sourceMappingURL=useEditor.js.map
